import { useState } from "react";
import { useCrew } from "../lib/crew";
import { JoinByLink } from "./JoinByLink";

// The sheet that opens from the crew name. Switching is a full page load on
// purpose: every screen's data is keyed to the acting crew, and a hard
// navigation guarantees nothing from the previous one survives the switch.
// Showing one crew's standings under another crew's name is the exact failure
// the whole crew-scoping effort exists to prevent.
export function CrewPicker({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { crews, crewId } = useCrew();
  // Folded away by default: this is the switcher, and joining is the rarer job.
  const [pasting, setPasting] = useState(false);
  if (!open) return null;

  return (
    <div className="sheet-scrim" onClick={onClose} role="presentation">
      <div className="sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Your crews">
        <div className="sheet-grip" aria-hidden="true" />
        <p className="sheet-title">Your crews</p>
        {crews.map((c) => (
          <button
            key={c.id}
            className={`sheet-row${c.id === crewId ? " current" : ""}`}
            onClick={() => { if (c.id !== crewId) window.location.href = `/league/${c.id}`; else onClose(); }}
          >
            <span className="sheet-row-name">{c.name}</span>
            <span className="sheet-row-meta">
              {c.role === "commissioner" ? "You host this one" : ""}
            </span>
            {c.id === crewId && <span className="sheet-row-check" aria-label="Current crew">✓</span>}
          </button>
        ))}
        {/* Somebody already in a crew who taps a link to a different one can
            land back here with nothing to show for it: on iPhone the installed
            app reads different storage from Safari, so the link never reaches
            it. This is where they say which crew they meant. */}
        {pasting ? (
          <JoinByLink label="Paste a crew link" cta="Join that crew" />
        ) : (
          <button className="btn ghost" onClick={() => setPasting(true)}>Join another crew</button>
        )}
        <button className="btn ghost" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
